import { Menu, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { MenuOption } from 'src/components/atoms/MenuOption';
import { useFilterContext } from 'src/contexts/FilterContext';
import { MenuList } from '../../molecules/MenuList';
import { Icon } from 'src/components/atoms/Icon';
import { MenuTriangle } from 'src/components/atoms/MenuTriangle';

const MENU_BUTTON_NAME = 'media-select';

export const MediaMenu: React.FC = () => {
  const { media, toggleMediaItem, toggleAllMediaItems } = useFilterContext();
  const fontActiveColor = useColorModeValue(
    'text.darkBlue.900',
    'text.dark.highContrast',
  );
  const selectedMediaCount = media.filter((t) => t.selected).length;

  const onAllClick = () => {
    toggleAllMediaItems();
  };

  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton buttonName={MENU_BUTTON_NAME} color={fontActiveColor}>
            <Icon iconName="database" width={6} height={6} mr={2} />
            {selectedMediaCount}/{media.length}
            <MenuTriangle isOpen={isOpen} />
          </MenuButton>
          <MenuList buttonName={MENU_BUTTON_NAME} onAllClick={onAllClick}>
            {media.map((item) => (
              <MenuOption
                buttonName={MENU_BUTTON_NAME}
                label={item.name}
                value={item.id}
                key={item.id}
                isDisabled={!item.isAvailable}
                isSelected={item.selected}
                onClick={() => toggleMediaItem(item)}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
};
